<template>
  <v-layout justify-center>
    <v-flex xs6>
      <v-card>
        <v-card-text class="text-center">
          <v-avatar>
            <v-icon x-large>account_circle</v-icon>
          </v-avatar>
        </v-card-text>
        <v-card-text>
          <v-alert type="error" v-if="errorMsg" :value="errorMsg" transition="fade-transition">{{ errorMsg }}</v-alert>
          <v-form>
            <v-text-field
              :label="$t('user.display_name')"
              v-model="form.displayName"
              :loading="loading"
              disabled
            ></v-text-field>
            <v-text-field
              :label="$t('user.email')"
              v-model="form.email"
              :loading="loading"
              disabled
            ></v-text-field>
            <v-text-field
              v-model="form.password"
              autocomplete="new-password"
              :label="$t('user.new_password')"
              :type="showPassword ? 'text' : 'password'"
              :append-icon="showPassword ? 'visibility' : 'visibility_off'"
              @click:append="showPassword = !showPassword"
            ></v-text-field>
            <v-text-field
              :label="$t('user.confirm_password')"
              :type="showPassword ? 'text' : 'password'"
              :append-icon="showPassword ? 'visibility' : 'visibility_off'"
              @click:append="showPassword = !showPassword"
              v-model="form.passwordConfirm"
            ></v-text-field>
            <v-flex class="text-center">
              <v-btn
                color="success"
                :loading="submitLoading"
                :disabled="submitLoading"
                @click="update"
              >{{ $t('update') }}</v-btn>
            </v-flex>
          </v-form>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import authService from '@/services/auth'

export default {
  data () {
    return {
      loading: false,

      submitLoading: false,

      showPassword: false,

      errorMsg: '',

      form: {
        displayName: null,
        email: null,
        password: '',
        passwordConfirm: ''
      }
    }
  },

  async created () {
    this.loading = true

    this.form.displayName = this.$store.state.userData.display_name
    this.form.email = this.$store.state.userData.email
    this.loading = false
  },

  methods: {
    async update () {
      this.errorMsg = ''
      this.submitLoading = true

      if (!this.form.password) {
        this.errorMsg = 'Please enter new password'
        this.submitLoading = false
        return
      }

      if (this.form.password !== this.form.passwordConfirm) {
        this.errorMsg = 'The confirm password is wrong'
        this.submitLoading = false
        return
      }

      const { data } = await authService.update(this.form)

      if (data.status === 'success') {
        this.$router.push({
          name: 'Home'
        })
        return
      }

      this.errorMsg = data.message
      this.submitLoading = false
    }
  }
}
</script>
